import React, { useEffect, useState } from "react";
import {
  Building,
  Calendar,
  Receipt,
  RefreshCw,
  X,
  Search,
  Eye,
} from "lucide-react";
import dayjs from "dayjs";
import axios from "axios";
import Modal from "../common/CommonModal";
import CreditCustomerList from "../common/CreditCustomerList";

const BankReconciliation = () => {
  const [selected, setSelected] = useState("value-1");
  const [ty, setTy] = useState("B");
  const doList = [];
  const [account, setAccount] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [accountsF2, setAccountsF2] = useState("success");
  const [loading, setLoading] = useState(false);
  const [brList, setBRList] = useState([]);
  const [editingRowId, setEditingRowId] = useState(null);
  const [editedDate, setEditedDate] = useState("");
  const [brDate, setBRDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [reconcileDate, setReconcileDate] = useState(
    dayjs().format("YYYY-MM-DD"),
  );
  const [bankBalance, setBankBalance] = useState(null);
  const [bookBalance, setBookBalance] = useState(null);
  const [unclearedBalance, setUnclearedBalance] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const roles = [
    { id: "value-1", label: "For Reconciliation", mode: "B" },
    { id: "value-2", label: "All", mode: "A" },
    { id: "value-3", label: "Only Reconciled", mode: "C" },
  ];

  const fetchAccountList = async (valueToAPI) => {
    setLoading(true);
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    // let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMAccountList/${companyCode}/ACCOUNTLIST/${department}/${valueToAPI}/-/-`;
    let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMAccountList/${companyCode}/ACCOUNTLIST/${department}/${valueToAPI}/-/-`;

    try {
      const response = await axios.get(apiUrl);
      setAccountsF2(response.data || []);
      console.log("response.data:", response.data);
    } catch (err) {
      console.error("Error while fetching voucher accounts", err);
    } finally {
      setLoading(false);
    }
  };

  const onShowBR = async () => {
    setLoading(true);
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMBankreconciliation/${companyCode}/BANKREC/${account}/${brDate}/${brDate}/${ty}`;
    // let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMBankreconciliation/${companyCode}/BANKREC/12010001/2025-12-30/2025-12-30/B`;
    // /api/CRMBankreconciliation/SUNRISEWEB/BANKREC/12010001/2025-12-30/2025-12-30/B

    try {
      const response = await axios.get(apiUrl);
      console.log("response.data BR List:", response.data);
      setBRList(response.data || []);
      fetchBalance();
      // fetchBookBalance();
      // fetchUnclearedBalance();
      setLoading(false);
    } catch (err) {
      console.error("Error while fetching BR List", err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  const fetchBalance = async () => {
    setLoading(true);
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMDocValues/${companyCode}/BR_BALANCE/${account}/${department}/${brDate}/${brDate}`;
    try {
      const response = await axios.get(apiUrl);
      console.log("response.data fetchBankBalance:", response.data[0]);
      setBankBalance(response.data[0]?.BALANCE_BANK);
      setBookBalance(response.data[0]?.BALANCE_BOOK);
      setUnclearedBalance(response.data[0]?.UNCLEARD_BALANCE);

      setLoading(false);
    } catch (err) {
      console.error("Error while fetchBankBalance", err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const onReconcile = async (row) => {
    setLoading(true);
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMBankReconUpdate`;

    const payload = [
      {
        CmpCode: companyCode,
        mode: reconcileDate ? "UPDATE" : "UPDATEBLANK",
        docid: row?.type_no,
        recdate: reconcileDate || "",
        deptno: row?.DEPTNO,
        dramount: row?.Debit,
        cramount: row?.Credit,
        jvtype: row?.JVType,
      },
    ];

    try {
      const response = await axios.post(apiUrl, payload);
      console.log("response.data fetchUnclearedBalance:", response.data[0]);
      onShowBR();
      setLoading(false);
    } catch (err) {
      console.error("Error while fetchUnclearedBalance", err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleCustomerSelect = (data) => {
    // console.log("data:", data);
    setAccount(data.ACCOUNT);
    setModalOpen(false);
  };

  const isShowDisabled = !brDate || !account;

  const filteredBRList = brList?.filter((row) =>
    [
      // row?.JVType,
      // row?.Description,
      // row?.AccountName,
      row?.type_no,
    ]
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="">
      <div className="my-4 mx-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <h2 className="text-xl text-gray-800 mt-4">Bank Reconciliation</h2>
          {/* Reconcile Date */}
          <div className="w-[50%]">
            <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
              <Calendar className="w-4 h-4 mr-2 text-gray-600" />
              Reconcile Date
            </label>
            <input
              type="date"
              value={reconcileDate}
              onChange={(e) => setReconcileDate(e.target.value)}
              className="w-full px-3 py-2.5 text-sm bg-gray-100 border-none rounded-lg
          focus:ring-2 focus:ring-purple-500 transition-all duration-200"
            />
          </div>

          {/* Search Bar */}
          <div>
            <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
              <Search className="w-4 h-4 mr-2 text-gray-600" />
              Search
            </label>
            <input
              type="text"
              disabled={isShowDisabled}
              placeholder="Search by Type No..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={`w-full px-3 py-2.5 text-sm bg-gray-100 border-none rounded-lg
          focus:ring-2 focus:ring-purple-500 transition-all duration-200
          ${
            isShowDisabled ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""
          }`}
            />
          </div>
        </div>
      </div>

      <div className="flex justify-center items-start">
        <div className="w-[26vw] h-[77vh] bg-gradient-to-br from-slate-50 via-white to-slate-50 shadow border-r border-slate-200 p-3 flex flex-col">
          <div className="flex-1 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-slate-300">
            {/* Role Selection - Custom Radio */}
            <div className="">
              <div className="mx-2">
                <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                  {/* <ArrowDownLeft className="w-4 h-4 mr-2 text-gray-600" /> */}
                  Account
                </label>
                <input
                  readOnly
                  value={account}
                  onChange={(e) => setAccount(e.target.value)}
                  placeholder="Press F2 to select account"
                  className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-purple-500 
                   placeholder-gray-400 transition-all duration-200 bg-gray-100"
                  onKeyDown={(e) => {
                    if (e.key === "F2") {
                      fetchAccountList("ALL");

                      setModalOpen(true);
                    }
                  }}
                />
              </div>

              <div className="bg-gray-100 my-4 mx-2 rounded-lg shadow text-sm">
                <p className="bg-blue-500 text-white text-center rounded-t-lg ">
                  Balance-Bank
                </p>
                <p className="text-center">{bankBalance || "-"}</p>
              </div>
              <div className="bg-gray-100 my-4 mx-2 rounded-lg shadow text-sm">
                <p className="bg-teal-500 text-white text-center rounded-t-lg">
                  Balance-Book
                </p>
                <p className="text-center">{bookBalance || "-"}</p>
              </div>
              <div className="bg-gray-100 my-4 mx-2  rounded-lg shadow text-sm">
                <p className="bg-yellow-500 text-white text-center rounded-t-lg">
                  Uncleared Balance with Bank
                </p>
                <p className="text-center">{unclearedBalance || "-"}</p>
              </div>

              <div className=" py-2 px-1 rounded-md space-y-3 ">
                {roles.map((role) => (
                  <label
                    key={role.id}
                    className={`
        relative flex items-center gap-4 px-2 h-10 rounded-xl cursor-pointer
        border-2 transition-all duration-300 ease-out
        ${
          selected === role.id
            ? "bg-gradient-to-r from-red-500 to-red-600 border-red-500 shadow scale-[1.01]"
            : "bg-white border-slate-200 hover:border-slate-300 hover:shadow hover:scale-[0.99]"
        }
      `}
                  >
                    <input
                      type="radio"
                      name="value-radio"
                      value={role.id}
                      checked={selected === role.id}
                      onChange={() => {
                        setTy(role.mode);
                        setSelected(role.id);
                        // setSelectedMod(role.id);
                      }}
                      className="sr-only"
                    />

                    {/* Custom Radio Circle */}
                    <div
                      className={`
          w-5 h-5 rounded-full flex items-center justify-center transition-all duration-200
          ${selected === role.id ? "bg-white" : "bg-slate-300"}
          ${selected === role.id ? "ring-4 ring-red-400 ring-opacity-30" : ""}
        `}
                    >
                      <div
                        className={`
            w-2 h-2 bg-red-600 rounded-full transition-transform duration-200
            ${selected === role.id ? "scale-100" : "scale-0"}
          `}
                      />
                    </div>

                    <p
                      className={`text-sm transition-colors ${
                        selected === role.id ? "text-white" : "text-slate-700"
                      }`}
                    >
                      {role.label}
                    </p>

                    {/* Pulse on select */}
                    {selected === role.id && (
                      <div className="absolute inset-0 rounded-xl bg-red-400 opacity-0" />
                    )}
                  </label>
                ))}
              </div>
              <div className="flex justify-center items-center gap-1 ">
                <div className=" w-full my-2">
                  <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                    <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                    Date
                  </label>
                  <input
                    type="date"
                    value={brDate}
                    onChange={(e) => setBRDate(e.target.value)}
                    className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                                 focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                                 transition-all duration-200"
                  />
                </div>

                {/* <div className="w-full">
                  <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                    <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                    To Date
                  </label>
                  <input
                    type="date"
                    // value={toDate}
                    // onChange={(e) => setToDate(e.target.value)}
                    className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                                 focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                                 transition-all duration-200"
                  />
                </div> */}
              </div>
            </div>
            {/* Action Buttons: Print & Export */}
            <div className="flex gap-3 py-2">
              <button
                onClick={onShowBR}
                disabled={isShowDisabled}
                className={`flex-1 flex items-center justify-center gap-2 
    font-medium px-2 py-2 rounded-lg text-sm
    transition-all duration-200
    ${
      isShowDisabled
        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
        : "bg-green-500 text-white shadow hover:shadow-md hover:scale-[1.02] active:scale-100"
    }`}
              >
                <Eye className="w-4 h-4" />
                Show
              </button>

              {/* <button
                // onClick={fetchDOList}
                className="flex-1 flex items-center justify-center gap-2 
                                   bg-orange-500 text-white 
                                   font-medium px-2 py-2 rounded-lg shadow hover:shadow-md 
                                   transform hover:scale-[1.02] active:scale-100 
                                   transition-all duration-200 text-sm"
              >
                <X className="w-4 h-4" />
                Close
              </button> */}
            </div>
            {isShowDisabled && (
              <p className="text-xs text-red-500 ">
                Select Account and Date to continue
              </p>
            )}
          </div>
        </div>
        <div className="w-full h-[77vh] overflow-auto shadow">
          <table className="relative text-xs border-collapse w-full">
            <thead>
              <tr className="">
                <th className="z-20 bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Action
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  JV Type
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Type No
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Date
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Description
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Chq No
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Debit
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1 text-right">
                  Credit
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1 text-right">
                  Type
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1 text-right">
                  Bank Date
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  Dept No
                </th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={11} className="py-6 text-center">
                    <div className="flex items-center justify-center gap-2 text-gray-600">
                      <span className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600"></span>
                      Loading data...
                    </div>
                  </td>
                </tr>
              ) : filteredBRList?.length > 0 ? (
                filteredBRList.map((row, index) => (
                  <tr key={index} className="text-xs">
                    <td className="z-10  border bg-white px-2 py-1 text-center">
                      <button
                        onClick={() => onReconcile(row)}
                        className="flex items-center justify-center gap-2 
                bg-blue-500 text-white 
                font-medium p-1 rounded-lg shadow hover:shadow-md 
                transform hover:scale-[1.02] active:scale-100 
                transition-all duration-200 text-xs"
                      >
                        {/* <RefreshCw className="w-4 h-4" /> */}
                        Reconcile
                      </button>
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {row?.JVType ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {row?.type_no ?? "-"}
                    </td>

                    {/* Editable Date */}
                    {/* <td
                      className="border bg-white px-2 py-1 text-center cursor-pointer"
                      onDoubleClick={() => {
                        setEditingRowId(row.id);
                        setEditedDate(
                          row?.Date ? dayjs(row.Date).format("YYYY-MM-DD") : ""
                        );
                      }}
                    >
                      {editingRowId === row.id ? (
                        <input
                          type="date"
                          value={editedDate}
                          onChange={(e) => setEditedDate(e.target.value)}
                          onBlur={() => {
                            handleDateUpdate(row.id, editedDate);
                            setEditingRowId(null);
                          }}
                          className="border px-1 py-0.5 text-xs w-full text-center"
                          autoFocus
                        />
                      ) : row?.Date ? (
                        dayjs(row.Date).format("DD/MM/YYYY")
                      ) : (
                        "-"
                      )}
                    </td> */}
                    <td className="border bg-white px-2 py-1 text-center cursor-pointer">
                      {row?.Date ? dayjs(row.Date).format("DD/MM/YYYY") : "-"}
                    </td>

                    <td className="border bg-white px-2 py-1 text-left">
                      {row?.Description ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {row?.Chqno ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-right">
                      {row?.Debit ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-right">
                      {row?.Credit ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {row?.type ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {/* {row?.Bank_Date ?? "-"} */}
                      {row?.Bank_Date
                        ? dayjs(row.Bank_Date).format("DD/MM/YYYY")
                        : "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {row?.DEPTNO ?? "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={11} className="text-center py-4 text-gray-500">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {modalOpen && (
        // <BRF2Popup setPdcDrModalOpen={setModalOpen} accounts={accountsF2} />
        <Modal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          title={"Ledger List"}
          size="xxl"
          header={true}
        >
          <CreditCustomerList
            defaultType="Bank"
            handleCustomerSelect={handleCustomerSelect}
          />
          {/* <ProductListing/> */}
        </Modal>
      )}
    </div>
  );
};

export default BankReconciliation;
